import { createAction, props } from '@ngrx/store';
import { ApiPagingConfig } from 'src/app/shared/models/paging/ApiPagingConfig';
import { ListCardItem } from 'src/app/shared/components/cards/list-card/models/ListCardItem';

export const ReportsActionTypes = {
  GET_DOWNLOAD: '[REPORTS] get download',
  GET_REPORTS: '[REPORTS] get reports',
  CLEAR_REPORTS: '[REPORTS] clear reports',
  GET_REPORTS_SUCCESS: '[REPORTS] get reports success',
  GET_REPORT: '[REPORTS] get report',
  CLEAR_REPORT: '[REPORTS] clear report',
  GET_REPORT_SUCCESS: '[REPORTS] get report success'
};

export const GetReports = createAction(
  ReportsActionTypes.GET_REPORTS,
  props<{
    paging: ApiPagingConfig;
  }>()
);

export const GetReportsSuccess = createAction(
  ReportsActionTypes.GET_REPORTS_SUCCESS,
  props<{
    reports: [];
    totalCount: string;
  }>()
);

export const GetReport = createAction(
  ReportsActionTypes.GET_REPORT,
  props<{ id: string }>()
);

export const GetDownload = createAction(
  ReportsActionTypes.GET_DOWNLOAD,
  props<{ id: string }>()
);

export const GetReportSuccess = createAction(
  ReportsActionTypes.GET_REPORT_SUCCESS,
  props<{ report: ListCardItem }>()
);

export const ClearReports = createAction(
  ReportsActionTypes.CLEAR_REPORTS
);

export const ClearReport = createAction(
  ReportsActionTypes.CLEAR_REPORT
);
